import React from 'react';
import ReactDOM from 'react-dom/client';
import './app/index.css';
import App from './app/App';
import reportWebVitals from './app/reportWebVitals';
import AppProviders from './app/providers/AppProviders';
import { startAnalytics } from './features/analytics/startAnalytics';
import { initializeLogging } from './shared/utils/loggingBootstrap.js';
import { bootObservability } from './shared/observability/boot';

bootObservability();
initializeLogging();
startAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
